export const folderNameRegex = /^[a-zA-Z0-9_]+$/

export const verisonRegex = /^[0-9.]+$/